export default function Services() {
  const services = [
    {
      icon: 'ri-palette-line',
      title: 'ブランディング',
      subtitle: 'Brand Strategy',
      description: 'ブランドアイデンティティの構築から、ロゴデザイン、ブランドガイドラインの策定まで、一貫したブランド戦略をご提案します。',
      features: ['ロゴデザイン', 'ブランドガイドライン', 'VI・CI構築', 'ネーミング開発'],
      color: 'from-red-500 to-pink-500',
      borderColor: 'border-red-500/30 hover:border-red-400/50',
      shadowColor: 'shadow-red-500/50'
    },
    {
      icon: 'ri-megaphone-line',
      title: '広告制作',
      subtitle: 'Creative Production',
      description: 'テレビCM、Web広告、グラフィック広告など、あらゆるメディアに対応した創造性豊かな広告制作を行います。',
      features: ['テレビCM制作', 'Web広告', 'グラフィック広告', 'コピーライティング'],
      color: 'from-orange-500 to-yellow-500',
      borderColor: 'border-orange-500/30 hover:border-orange-400/50',
      shadowColor: 'shadow-orange-500/50'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'デジタルマーケティング',
      subtitle: 'Digital Marketing',
      description: 'SNS運用、SEO対策、リスティング広告など、デジタル領域での包括的なマーケティング支援を提供します。',
      features: ['SNS運用代行', 'SEO対策', 'リスティング広告', 'アクセス解析'],
      color: 'from-yellow-500 to-green-500',
      borderColor: 'border-yellow-500/30 hover:border-yellow-400/50',
      shadowColor: 'shadow-yellow-500/50'
    },
    {
      icon: 'ri-camera-line',
      title: '映像制作',
      subtitle: 'Video Production',
      description: '企業PR動画、商品紹介動画、イベント映像など、高品質な映像コンテンツの企画・制作を手がけます。',
      features: ['企業PR動画', '商品紹介動画', 'イベント映像', 'アニメーション制作'],
      color: 'from-green-500 to-blue-500',
      borderColor: 'border-green-500/30 hover:border-green-400/50',
      shadowColor: 'shadow-green-500/50'
    },
    {
      icon: 'ri-global-line',
      title: 'Webサイト制作',
      subtitle: 'Web Development',
      description: 'コーポレートサイトからECサイトまで、戦略的思考に基づいたWebサイトの企画・制作・運用を行います。',
      features: ['コーポレートサイト', 'ECサイト構築', 'ランディングページ', 'CMS構築'],
      color: 'from-blue-500 to-purple-500',
      borderColor: 'border-blue-500/30 hover:border-blue-400/50',
      shadowColor: 'shadow-blue-500/50'
    },
    {
      icon: 'ri-presentation-line',
      title: 'イベント企画',
      subtitle: 'Event Planning',
      description: '記者発表会、展示会、セミナーなど、企業の重要なイベントの企画・運営を総合的にサポートします。',
      features: ['記者発表会', '展示会企画', 'セミナー運営', 'キャンペーン企画'],
      color: 'from-purple-500 to-pink-500',
      borderColor: 'border-purple-500/30 hover:border-purple-400/50',
      shadowColor: 'shadow-purple-500/50'
    }
  ];

  return (
    <section id="services" className="py-32 bg-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(239, 68, 68, 0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(239, 68, 68, 0.3) 1px, transparent 1px)',
          backgroundSize: '80px 80px'
        }}></div>
      </div>

      <div className="container mx-auto px-6 relative">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <div className="inline-block mb-6">
              <span className="text-red-400 text-sm font-bold tracking-widest" style={{ fontFamily: '"Montserrat", sans-serif' }}>OUR SERVICES</span>
            </div>
            <h2 className="text-6xl font-black text-white mb-8" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              サービス一覧
            </h2>
            <div className="flex items-center justify-center gap-4">
              <div className="w-32 h-1 bg-gradient-to-r from-transparent via-red-500 to-transparent rounded-full"></div>
              <div className="w-4 h-4 bg-red-500 rounded-full"></div>
              <div className="w-32 h-1 bg-gradient-to-r from-transparent via-orange-500 to-transparent rounded-full"></div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className={`group relative bg-white/5 backdrop-blur-xl rounded-3xl border ${service.borderColor} p-8 hover:bg-white/10 transition-all hover:shadow-2xl hover:${service.shadowColor} hover:-translate-y-4 duration-300`}
              >
                <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity"></div>
                
                <div className="relative">
                  <div className={`w-16 h-16 bg-gradient-to-br ${service.color} rounded-2xl flex items-center justify-center mb-6 shadow-xl ${service.shadowColor} group-hover:scale-110 transition-transform`}>
                    <i className={`${service.icon} text-3xl text-white`}></i>
                  </div>
                  
                  <div className="mb-6">
                    <h3 className="text-2xl font-black text-white mb-2" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                      {service.title}
                    </h3>
                    <p className="text-red-400 text-sm font-semibold tracking-wide" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                      {service.subtitle}
                    </p>
                  </div>
                  
                  <p className="text-gray-300 leading-relaxed mb-6 text-sm" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                    {service.description}
                  </p>
                  
                  <div className="space-y-2">
                    {service.features.map((feature, featureIndex) => (
                      <div key={featureIndex} className="flex items-center gap-2">
                        <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                        <span className="text-gray-400 text-xs font-medium" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                          {feature}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}